import React from 'react';
import ButtonComponent from '../../Components/Button/button';
import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { USER_MANAGEMENT } from '../../Constants/strings';

const ActionButtons = ({
  hasAccess,
  selectedRows,
  handleMapUsersClick,
  handleRemoveRoleClick,
}) => {
  return (
    <div className="users-button">
      <Tooltip
        classes={{ tooltip: 'map-role-btn-tooltip' }}
        disableFocusListener={selectedRows.length !== 0}
        disableHoverListener={selectedRows.length !== 0}
        title={USER_MANAGEMENT.TOOLTIP}
      >
        <div style={{ display: 'flex', gap: '10px' }}>
          <ButtonComponent
            disabled={!hasAccess('create') || selectedRows.length === 0}
            id="add-users-btn"
            label="Map Role"
            variant="contained"
            onClick={handleMapUsersClick}
            btnCss={'add-users-btn'}
          />
          <ButtonComponent
            disabled={!hasAccess('delete') || selectedRows.length === 0}
            id="remove-users-role-btn"
            label="Remove Role"
            variant="outlined"
            onClick={handleRemoveRoleClick}
            btnCss={'remove-users-role-btn'}
          />
        </div>
      </Tooltip>
    </div>
  );
};

ActionButtons.propTypes = {
  hasAccess: PropTypes.func.isRequired,
  selectedRows: PropTypes.array.isRequired,
  handleMapUsersClick: PropTypes.func.isRequired,
  handleRemoveRoleClick: PropTypes.func,
};

export default ActionButtons;
